// // import React, { useState, useRef } from "react";

// // const ImageSlider = () => {
// //   const [sliderPosition, setSliderPosition] = useState(50); // Default slider position at 50%
// //   const [isDragging, setIsDragging] = useState(false); // State to track if the slider is being dragged
// //   const containerRef = useRef(null);

// //   const handleInteractionStart = (clientX) => {
// //     const container = containerRef.current;
// //     const rect = container.getBoundingClientRect();
// //     const newPosition = ((clientX - rect.left) / container.offsetWidth) * 100;
// //     if (newPosition >= 0 && newPosition <= 100) {
// //       setSliderPosition(newPosition);
// //     }
// //     setIsDragging(true);
// //   };

// //   const handleInteractionMove = (clientX) => {
// //     if (isDragging) {
// //       const container = containerRef.current;
// //       const rect = container.getBoundingClientRect();
// //       const newPosition = ((clientX - rect.left) / container.offsetWidth) * 100;
// //       if (newPosition >= 0 && newPosition <= 100) {
// //         setSliderPosition(newPosition);
// //       }
// //     }
// //   };

// //   const handleInteractionEnd = () => {
// //     setIsDragging(false);
// //   };

// //   const handleMouseDown = (event) => {
// //     handleInteractionStart(event.clientX);
// //   };

// //   const handleMouseMove = (event) => {
// //     handleInteractionMove(event.clientX);
// //   };

// //   const handleTouchStart = (event) => {
// //     handleInteractionStart(event.touches[0].clientX);
// //   };

// //   const handleTouchMove = (event) => {
// //     handleInteractionMove(event.touches[0].clientX);
// //   };

// //   return (
// //     <div
// //       ref={containerRef}
// //       onMouseDown={handleMouseDown}
// //       onMouseMove={handleMouseMove}
// //       onMouseUp={handleInteractionEnd}
// //       onMouseLeave={handleInteractionEnd}
// //       onTouchStart={handleTouchStart}
// //       onTouchMove={handleTouchMove}
// //       onTouchEnd={handleInteractionEnd}
// //       className="relative w-full max-w-3xl h-64 mx-auto cursor-pointer select-none"
// //     >
// //       <img
// //         src="https://images.unsplash.com/photo-1568605114967-8130f3a3698b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjUyOXwwfDF8c2VhcmNofDIxfHxuYXR1cmV8ZW58MHx8fHwxNjU3ODUyMTYz&ixlib=rb-1.2.1&q=80&w=1080"
// //         className="absolute top-0 left-0 w-full h-full object-cover"
// //         alt="Nature"
// //       />
// //       <div
// //         className="absolute top-0 left-0 w-full h-full"
// //         style={{
// //           clipPath: `polygon(0 0, ${sliderPosition}% 0, ${sliderPosition}% 100%, 0 100%)`,
// //         }}
// //       >
// //         <img
// //           src="https://images.unsplash.com/photo-1534080564583-6be75777b70a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjUyOXwwfDF8c2VhcmNofDl8fGNpdHl8ZW58MHx8fHwxNjU3ODUyMjk1&ixlib=rb-1.2.1&q=80&w=1080"
// //           className="absolute top-0 left-0 w-full h-full object-cover"
// //           alt="City"
// //         />
// //       </div>
// //       <div
// //         className="absolute top-0 bg-white h-full"
// //         style={{ left: `${sliderPosition}%`, width: "6px" }}
// //       ></div>
// //     </div>
// //   );
// // };

// // export default ImageSlider;
// import React, { useState, useRef } from "react";

// const ImageSlider = () => {
//   const [sliderPosition, setSliderPosition] = useState(50); // Default slider position at 50%
//   const [isDragging, setIsDragging] = useState(false); // State to track if the slider is being dragged
//   const containerRef = useRef(null);

//   const handleInteractionStart = (clientX) => {
//     const container = containerRef.current;
//     const rect = container.getBoundingClientRect();
//     const newPosition = ((clientX - rect.left) / container.offsetWidth) * 100;
//     if (newPosition >= 0 && newPosition <= 100) {
//       setSliderPosition(newPosition);
//     }
//     setIsDragging(true);
//   };

//   const handleInteractionMove = (clientX) => {
//     if (isDragging) {
//       const container = containerRef.current;
//       const rect = container.getBoundingClientRect();
//       const newPosition = ((clientX - rect.left) / container.offsetWidth) * 100;
//       if (newPosition >= 0 && newPosition <= 100) {
//         setSliderPosition(newPosition);
//       }
//     }
//   };

//   const handleInteractionEnd = () => {
//     setIsDragging(false);
//   };

//   const handleMouseDown = (event) => {
//     handleInteractionStart(event.clientX);
//   };

//   const handleMouseMove = (event) => {
//     handleInteractionMove(event.clientX);
//   };

//   const handleTouchStart = (event) => {
//     handleInteractionStart(event.touches[0].clientX);
//   };

//   const handleTouchMove = (event) => {
//     handleInteractionMove(event.touches[0].clientX);
//   };

//   return (
//     <div
//       ref={containerRef}
//       onMouseDown={handleMouseDown}
//       onMouseMove={handleMouseMove}
//       onMouseUp={handleInteractionEnd}
//       onMouseLeave={handleInteractionEnd}
//       onTouchStart={handleTouchStart}
//       onTouchMove={handleTouchMove}
//       onTouchEnd={handleInteractionEnd}
//       className="relative w-full max-w-3xl h-64 mx-auto cursor-pointer select-none"
//     >
//       <img
//         src="https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80" // A placeholder nature image
//         className="absolute top-0 left-0 w-full h-full object-cover"
//         alt="Left Image"
//       />
//       <div
//         className="absolute top-0 left-0 w-full h-full"
//         style={{
//           clipPath: `polygon(0 0, ${sliderPosition}% 0, ${sliderPosition}% 100%, 0 100%)`,
//         }}
//       >
//         <img
//           src="https://plus.unsplash.com/premium_photo-1730828573938-003e14f210f4?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" // A placeholder city image
//           className="absolute top-0 left-0 w-full h-full object-cover"
//           alt="Right Image"
//         />
//       </div>
//       <div
//         className="absolute top-0 h-full"
//         style={{
//           left: `${sliderPosition}%`,
//           width: "2px",
//           background: "white",
//         }}
//       >
//         <div
//           className="w-8 h-8 bg-white rounded-full flex items-center justify-center text-black absolute"
//           style={{ left: "-12px", top: "50%", transform: "translateY(-50%)" }}
//         >
//           <span>⇆</span> {/* Using a simple text icon for demonstration */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ImageSlider;
// version 2

import React, { useState, useRef, useEffect } from "react";

const ImageSlider = () => {
  const [sliderPosition, setSliderPosition] = useState(50); // Default slider position at 50%
  const [isDragging, setIsDragging] = useState(false); // State to track if the slider is being dragged
  const containerRef = useRef(null);
  const requestRef = useRef();

  const updateSliderPosition = (clientX) => {
    const container = containerRef.current;
    const rect = container.getBoundingClientRect();
    const newPosition = ((clientX - rect.left) / container.offsetWidth) * 100;

    if (newPosition >= 0 && newPosition <= 100) {
      setSliderPosition(newPosition);
    }
  };

  const handleInteractionStart = (clientX) => {
    setIsDragging(true);
    updateSliderPosition(clientX);
  };

  const handleInteractionMove = (clientX) => {
    if (isDragging) {
      // Use requestAnimationFrame to handle updates smoothly
      requestRef.current = requestAnimationFrame(() =>
        updateSliderPosition(clientX)
      );
    }
  };

  const handleInteractionEnd = () => {
    setIsDragging(false);
    // Cancel any frames that are scheduled but not yet executed
    if (requestRef.current) {
      cancelAnimationFrame(requestRef.current);
    }
  };

  // Setup mouse event handlers
  const handleMouseDown = (event) => {
    handleInteractionStart(event.clientX);
  };

  const handleMouseMove = (event) => {
    handleInteractionMove(event.clientX);
  };

  // Setup touch event handlers
  const handleTouchStart = (event) => {
    handleInteractionStart(event.touches[0].clientX);
  };

  const handleTouchMove = (event) => {
    handleInteractionMove(event.touches[0].clientX);
  };

  // Clean up on component unmount
  useEffect(() => {
    return () => {
      if (requestRef.current) {
        cancelAnimationFrame(requestRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleInteractionEnd}
      onMouseLeave={handleInteractionEnd}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleInteractionEnd}
      className="relative w-full max-w-3xl h-[35vh] md:h-[50vh] md:h-full mx-auto cursor-pointer select-none"
    >
      <img
        src="/Journey2.png"
        className="absolute top-0 left-0 w-full h-full object-fit rounded-xl"
        alt="Left Image"
      />
      <div
        className="absolute top-0 left-0 w-full h-full"
        style={{
          clipPath: `polygon(0 0, ${sliderPosition}% 0, ${sliderPosition}% 100%, 0 100%)`,
        }}
      >
        <img
          src="/Journey1.png"
          className="absolute top-0 left-0 w-full h-full object-fit rounded-xl"
          alt="Right Image"
        />
      </div>
      <div
        className="absolute top-0 bg-white h-full"
        style={{ left: `${sliderPosition}%`, width: "2px" }}
      >
        <div
          className="w-8 h-8 bg-white rounded-full flex items-center justify-center text-black absolute"
          style={{ left: "-12px", top: "50%", transform: "translateY(-50%)" }}
        >
          <span>⇆</span> {/* Using a simple text icon for demonstration */}
        </div>
      </div>
    </div>
  );
};

export default ImageSlider;
